<div sharedUiModalClose (closed)="closed.emit()"></div>

<div
  class="skeleton-animated bg-base-600 mr:mb-[40px] mr:w-[190px] mr:mt-0 mx-auto mb-[24px] mt-[4px] h-[32px] w-[46%] rounded-[16px]"
>
</div>

@for (i of rowsCount; track i) {
  <div
    class="skeleton-animated bg-base-600 mr:mx-[30px] mx-[20px] mb-[24px] h-[16px] rounded-[8px]"
  ></div>
}

<div class="mr:px-[30px] flex px-[20px] pt-[16px]">
  <div
    class="skeleton-animated bg-base-600 w-calc-50-minus-10 mr-[20px] h-[48px] rounded-[24px]"
  ></div>
  <div
    class="skeleton-animated bg-base-600 w-calc-50-minus-10 h-[48px] rounded-[24px]"
  ></div>
</div>
